(() => {
  const boot = () => document.querySelectorAll('[data-okhw]').forEach(mount);
  function mount(layer) {
    if (layer.dataset.mounted) return;
    const end = Date.parse(layer.dataset.until);
    if (!Number.isFinite(end) || Date.now() >= end) return;
    layer.dataset.mounted = 'true';
    const host = layer.closest('okhomes-hero-crossfade');
    const form = host?.querySelector('.okhomes-home-map__search');
    const spider = host?.querySelector('[data-okhw-spider]');
    const bat = host?.querySelector('[data-okhw-bat]');
    const image = layer.querySelector('img');
    if (!host || !form || !spider || !bat || !image) return;
    const q = selector => selector === '.ok-spider-drawing' ? spider.querySelector('canvas') : bat.querySelector('canvas');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let reduced = motion.matches;
    const flashCanvas = layer.querySelector('.okhw-bolts');
    const clamp = x => Math.max(0, Math.min(1, x));
    const smooth = x => { x = clamp(x); return x * x * (3 - 2 * x); };
    const abort = new AbortController();
    const options = { signal: abort.signal };
    let sound = false, audio = null, sources = [], paused = false, raf = 0, elapsed = 0, last = 0;
    let visible = true, destroyed = false, ready = false, dirty = true, lastStrike = -1;
    let geometry = null;
    const originalPaused = host.paused;
    let expiryTimer;
    const css = (name, value) => host.style.setProperty('--okhw-' + name, value);
    function stopSound() { sources.forEach(source => { try { source.stop(); } catch {} }); sources = []; }
    function thunder() {
      if (!sound || !audio) return;
      const duration = 4.5, t = audio.currentTime;
      const buffer = audio.createBuffer(1, Math.floor(audio.sampleRate * duration), audio.sampleRate);
      const samples = buffer.getChannelData(0); let brown = 0;
      for (let i = 0; i < samples.length; i++) { brown = (brown + .035 * (Math.random() * 2 - 1)) / 1.035; samples[i] = brown * 5; }
      const source = audio.createBufferSource(), filter = audio.createBiquadFilter(), gain = audio.createGain();
      source.buffer = buffer; filter.type = 'lowpass'; filter.frequency.setValueAtTime(950, t); filter.frequency.exponentialRampToValueAtTime(90, t + 4);
      gain.gain.setValueAtTime(.001, t); gain.gain.exponentialRampToValueAtTime(.55, t + .12); gain.gain.exponentialRampToValueAtTime(.001, t + duration);
      source.connect(filter).connect(gain).connect(audio.destination); source.start(); sources.push(source);
      source.onended = () => { sources = sources.filter(item => item !== source); };
    }
    function measure() {
      const r = host.getBoundingClientRect(), f = form.getBoundingClientRect();
      geometry = { width: r.width, height: r.height, left: f.left - r.left, top: f.top - r.top, formWidth: f.width, spiderWidth: spider.offsetWidth, spiderHeight: spider.offsetHeight, batWidth: bat.offsetWidth };
      dirty = false;
    }
    function bolt(seed) {
      const w = geometry.width, h = geometry.height, dpr = Math.min(devicePixelRatio || 1, 2);
      flashCanvas.width = w * dpr; flashCanvas.height = h * dpr;
      const c = flashCanvas.getContext('2d'); if (!c) return;
      c.scale(dpr, dpr); let x = w * (seed % 2 ? .22 : .79), y = 0;
      c.strokeStyle = '#ecf3ff'; c.lineWidth = 2; c.shadowColor = '#b0c4ff'; c.shadowBlur = 15; c.lineJoin = 'round'; c.beginPath(); c.moveTo(x, y);
      while (y < Math.min(h * .53, geometry.top - 20)) { x += (Math.random() - .5) * w * .1; y += h * (.018 + Math.random() * .026); c.lineTo(x, y); }
      c.stroke();
    }
    function render(ms) {
      if (dirty) measure();
      const raw = (ms % 28000) / 1000;
      const t = raw < 8 ? raw * .3 : raw - 5.6;
      const reveal = smooth((t - 4.6) / 2.6), back = smooth((t - 16) / 3);
      const scene = reveal * (1 - back), dim = smooth((t - 2.4) / 1.6);
      css('scene', scene); css('brand', 1 - scene);
      css('night', dim * .72 * (1 - smooth((t - 6.2) / 2.2)));
      css('fog', .65 * smooth((t - 2.3) / 2) * (1 - smooth((t - 7.2) / 2.5)));
      css('drift', Math.sin(t * .35) * 5 + '%');
      const g = geometry, walk = (raw % 12) / 12, morph = smooth((raw - 10.2) / 1.1);
      const travel = Math.max(0, g.formWidth - g.spiderWidth - 8);
      const sx = g.left + 4 + travel * (1 - walk), sy = Math.max(0, g.top - g.spiderHeight + 1);
      spider.style.transform = `translate(${sx}px,${sy}px) scale(${raw < 11.3 ? 1 - morph * .55 : 1})`;
      spider.style.opacity = (raw < 10.2 ? 1 : raw < 11.3 ? 1 - morph : back) * Math.min(smooth(walk / .025), smooth((1 - walk) / .025));
      drawSpider(raw);
      const p = clamp((raw - 11.3) / 5.2), ease = smooth(p);
      const startX = g.left + 4 + travel * (1 - 10.2 / 12), targetX = g.width * (g.width < 750 ? .79 : .73) - g.batWidth / 2;
      const x = startX + (targetX - startX) * ease + Math.sin(p * Math.PI * 8) * Math.sin(p * Math.PI) * g.width * .1;
      const y = sy * (1 - ease) + Math.sin(p * Math.PI * 6) * Math.sin(p * Math.PI) * g.height * .025;
      bat.style.transform = `translate(${x}px,${Math.max(0, y)}px) scale(${.5 + .5 * morph})`;
      bat.style.opacity = morph * (1 - back); drawBat(raw, p >= 1, p >= 1 ? 0 : Math.sin(p * Math.PI * 8) * .3);
      let flash = 0;
      for (const [i, at] of [9.85, 11.05].entries()) {
        const dt = raw - at, key = Math.floor(ms / 28000) * 2 + i;
        if (dt >= 0 && dt < .6) { flash = Math.max(flash, Math.exp(-dt * 7) * .68); if (key !== lastStrike) { bolt(i + 1); thunder(); lastStrike = key; } }
      }
      css('flash', flash);
    }
    function frame(now) {
      raf = 0;
      if (Date.now() >= end) { destroy(); return; }
      if (!ready || paused || reduced || document.hidden || !visible) { last = 0; return; }
      if (last) elapsed += Math.min(now - last, 100);
      last = now; render(elapsed); raf = requestAnimationFrame(frame);
    }
    function schedule() {
      cancelAnimationFrame(raf); raf = 0; last = 0;
      if (Date.now() >= end) { destroy(); return; }
      if (destroyed || !ready || paused || reduced || document.hidden || !visible) { stopSound(); return; }
      raf = requestAnimationFrame(frame);
    }
    function destroy() {
      if (destroyed) return; destroyed = true;
      cancelAnimationFrame(raf); clearTimeout(expiryTimer); stopSound(); audio?.close(); abort.abort(); observer?.disconnect(); resize?.disconnect();
      host.classList.remove('okhw-active');
      ['scene', 'brand', 'night', 'fog', 'drift', 'flash'].forEach(key => host.style.removeProperty('--okhw-' + key));
      layer.remove(); spider.remove(); bat.remove();
      if (typeof originalPaused === 'boolean') { host.paused = originalPaused; host.schedule?.(); }
    }
    document.addEventListener('visibilitychange', schedule, options);
    motion.addEventListener('change', () => { reduced = motion.matches; if (reduced) { host.classList.remove('okhw-active'); layer.hidden = true; spider.hidden = true; bat.hidden = true; } else activate(); schedule(); }, options);
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }) : null;
    const resize = 'ResizeObserver' in window ? new ResizeObserver(() => { dirty = true; }) : null;
    observer?.observe(host); resize?.observe(host); resize?.observe(form);
    window.addEventListener('resize', () => { dirty = true; }, options);
    expiryTimer = setTimeout(destroy, Math.max(0, end - Date.now()));
    function activate() {
      if (destroyed || Date.now() >= end || reduced || !ready) return;
      host.paused = true; host.schedule?.(); host.classList.add('okhw-active');
      layer.hidden = false; spider.hidden = false; bat.hidden = false;
      spider.style.left = bat.style.left = '0'; spider.style.top = bat.style.top = '0';
      measure(); render(elapsed);
    }
    const loaded = async () => {
      try { await image.decode(); } catch { return; }
      if (!image.naturalWidth || destroyed || Date.now() >= end) return;
      ready = true; activate(); schedule();
    };
    if (image.complete) loaded(); else image.addEventListener('load', loaded, { ...options, once: true });
     function drawSpider(time){
  const cv=q('.ok-spider-drawing'),c=cv.getContext('2d');
  c.setTransform(2,0,0,2,0,0);c.clearRect(0,0,120,84);
  const speed=reduced?0:time/.94, bob=reduced?0:Math.cos(speed*Math.PI*4)*.6;
  c.save();c.translate(0,bob);
  const legs=(far)=>{
   const hips=[43,49,59,68],feet=far?[16,38,76,100]:[10,32,72,106];
   for(let i=0;i<4;i++){
    const phase=(speed+(i%2)*.5+(far?.5:0))%1;
    const stance=phase<.64, f=stance?phase/.64:(phase-.64)/.36;
    const dx=stance?-9+18*f:9-18*f;
    const lift=stance?0:Math.sin(f*Math.PI)*12;
    const hx=hips[i],hy=far?46:49,tx=feet[i]+dx,ty=(far?78:82)-lift-bob;
    const kneeX=hx+(tx-hx)*.62+(i<2?-7:7),kneeY=55-lift*.35;
    c.lineCap='round';c.lineJoin='round';
    c.strokeStyle=far?'#302c2a':'#141313';c.lineWidth=far?3.8:4.5;
    c.beginPath();c.moveTo(hx,hy);c.lineTo(kneeX,kneeY);c.lineTo(tx,ty);c.stroke();
    c.strokeStyle=far?'#645b54':'#60554d';c.lineWidth=.9;
    c.beginPath();c.moveTo(hx,hy-1);c.lineTo(kneeX,kneeY-1);c.lineTo(tx,ty-1);c.stroke();
    c.fillStyle=far?'#302c2a':'#141313';c.beginPath();c.ellipse(tx-1,ty,2.5,1.15,0,0,Math.PI*2);c.fill();
   }
  };
  legs(true);
  let fill=c.createRadialGradient(62,31,2,68,42,25);fill.addColorStop(0,'#71645a');fill.addColorStop(.4,'#3c342f');fill.addColorStop(1,'#171515');
  c.fillStyle=fill;c.beginPath();c.ellipse(68,41,22,18,-.1,0,Math.PI*2);c.fill();
  c.strokeStyle='#665a50';c.lineWidth=.7;
  for(let i=0;i<27;i++){const a=i/27*Math.PI*2,x=68+Math.cos(a)*21,y=41+Math.sin(a)*17;c.beginPath();c.moveTo(x,y);c.lineTo(x+Math.cos(a)*3,y+Math.sin(a)*3);c.stroke();}
  c.fillStyle='#211e1c';c.beginPath();c.ellipse(44,45,17,14,.08,0,Math.PI*2);c.fill();
  legs(false);
  for(const [x,y,r] of [[34,39,6.7],[46,37,7.5]]){
   c.fillStyle='#0b0b0c';c.beginPath();c.ellipse(x,y,r+1.4,r+1.6,0,0,Math.PI*2);c.fill();
   c.fillStyle='#ffffff';c.beginPath();c.ellipse(x,y,r,r+.3,0,0,Math.PI*2);c.fill();
   c.fillStyle='#171717';c.beginPath();c.ellipse(x-2,y+.3,r*.4,r*.53,0,0,Math.PI*2);c.fill();
   c.fillStyle='#ffffff';c.beginPath();c.arc(x-2.8,y-1.4,1.1,0,Math.PI*2);c.fill();
  }
  c.fillStyle='#b6aba0';for(const x of [29,55]){c.beginPath();c.arc(x,34,1.6,0,Math.PI*2);c.fill();}
  c.strokeStyle='#857365';c.lineWidth=2;c.beginPath();c.moveTo(29,48);c.quadraticCurveTo(22,50,25,54);c.moveTo(35,51);c.quadraticCurveTo(29,54,32,57);c.stroke();
  c.restore();
 }

 function drawBat(time,sleep,bank){
  const cv=q('.ok-bat-drawing'),c=cv.getContext('2d');
  c.setTransform(2,0,0,2,0,0);c.clearRect(0,0,120,84);
  c.lineCap='round';c.lineJoin='round';
  if(sleep){
   c.strokeStyle='#9a8474';c.lineWidth=2;
   for(const x of [54,64]){c.beginPath();c.moveTo(x,12);c.lineTo(x,2);c.quadraticCurveTo(x-2,-1,x-4,2);c.stroke();}
   c.save();c.translate(59,30);c.scale(1,1+Math.sin(time*1.5)*.012);
   let g=c.createLinearGradient(-16,0,16,0);g.addColorStop(0,'#16131a');g.addColorStop(.5,'#514052');g.addColorStop(1,'#171219');
   c.fillStyle=g;c.beginPath();c.moveTo(-7,-18);c.quadraticCurveTo(-24,-7,-18,19);c.quadraticCurveTo(-11,34,0,29);c.quadraticCurveTo(14,30,19,15);c.quadraticCurveTo(24,-6,7,-18);c.closePath();c.fill();
   c.strokeStyle='#746074';c.lineWidth=.9;c.beginPath();c.moveTo(-14,-7);c.quadraticCurveTo(-2,2,7,26);c.moveTo(14,-7);c.quadraticCurveTo(4,2,-1,28);c.stroke();
   c.fillStyle='#29202b';c.beginPath();c.ellipse(0,27,10,9,0,0,Math.PI*2);c.fill();
   c.beginPath();c.moveTo(-8,28);c.lineTo(-12,39);c.lineTo(-2,34);c.moveTo(8,28);c.lineTo(12,39);c.lineTo(2,34);c.fill();
   c.strokeStyle='#f0e9ef';c.lineWidth=1.6;
   for(const x of [-4,4]){c.beginPath();c.moveTo(x-2,28);c.quadraticCurveTo(x,26.5,x+2,28);c.stroke();}
   c.fillStyle='#9a7c91';c.beginPath();c.arc(0,31,1.3,0,Math.PI*2);c.fill();c.restore();return;
  }
  c.save();c.translate(60,40);c.rotate(bank);
  const flap=reduced?.65:.4+.6*(.5+.5*Math.sin(time*16));
  c.save();c.scale(1,flap);
  for(const side of [-1,1]){
   c.save();c.scale(side,1);
   const g=c.createLinearGradient(4,-26,48,17);g.addColorStop(0,'#615064');g.addColorStop(1,'#1a1420');c.fillStyle=g;c.strokeStyle='#a082a4';c.lineWidth=1;
   c.beginPath();c.moveTo(5,-5);c.quadraticCurveTo(22,-26,51,-30);c.quadraticCurveTo(48,-13,53,9);c.quadraticCurveTo(40,-2,34,14);c.quadraticCurveTo(23,3,20,21);c.quadraticCurveTo(13,9,6,13);c.closePath();c.fill();c.stroke();
   c.strokeStyle='#9a789d';c.lineWidth=.8;c.beginPath();c.moveTo(7,-3);c.lineTo(51,-30);c.moveTo(7,-3);c.lineTo(34,14);c.moveTo(7,-3);c.lineTo(20,21);c.stroke();c.restore();
  }c.restore();
  c.fillStyle='#2e2432';c.beginPath();c.ellipse(0,3,8,15,0,0,Math.PI*2);c.fill();
  c.fillStyle='#3e3041';c.beginPath();c.ellipse(0,-9,10,9,0,0,Math.PI*2);c.fill();
  c.beginPath();c.moveTo(-8,-11);c.lineTo(-11,-25);c.lineTo(-2,-16);c.moveTo(8,-11);c.lineTo(11,-25);c.lineTo(2,-16);c.fill();
  for(const x of [-4,4]){c.fillStyle='#fff';c.beginPath();c.ellipse(x,-10,3.5,4,0,0,Math.PI*2);c.fill();c.fillStyle='#19131c';c.beginPath();c.arc(x,-9.5,1.5,0,Math.PI*2);c.fill();}
  c.strokeStyle='#aa8ca7';c.lineWidth=1.3;c.beginPath();c.moveTo(-3,-3);c.quadraticCurveTo(0,-1,3,-3);c.stroke();c.restore();
 }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
